// 单页内容站 · 全部静态展示数据（不涉及真实人物诽谤，均为公开信息求真的类型化样本）

export const stats = [
  { key: "total", value: "1286", label: "累计求证传闻" },
  { key: "refuted", value: "612", label: "查无实据" },
  { key: "confirmed", value: "214", label: "证据坐实" },
  { key: "reversed", value: "139", label: "经历反转" },
];

export const categories = [
  "全部栏目",
  "食品安全",
  "医疗健康",
  "消费电商",
  "政策法规",
  "娱乐圈",
  "社会热点",
  "商界争议",
];

export type VerifyStatus =
  | "confirmed"
  | "refuted"
  | "partial"
  | "reversed"
  | "reviewing";

export interface VerifyItem {
  id: number;
  category: string;
  title: string;
  date: string;
  status: VerifyStatus;
  summary: string;
  tags: string[];
  verdict: string[];
}

export const verifyItems: VerifyItem[] = [
  {
    id: 1,
    category: "食品安全",
    title: "网传“注胶虾”大量流入市场的视频，属实吗？",
    date: "2026-09-04",
    status: "refuted",
    summary:
      "该视频实为多年前某地查处的个案，被掐头去尾后反复传播，误导成“全国性事件”。我们回溯了原始素材与属地通报，确认属于旧闻翻炒。",
    tags: ["旧闻翻炒", "断章取义", "个案放大"],
    verdict: [
      "原始视频拍摄于 2023 年，为单一起处的执法个案，并非“大量流入市场”。",
      "同期多地市场监管部门均未发布该类大规模通报，视频中的旁白时间与画面不符。",
      "经与属地通报核对，事件性质为加工环节违规，结论已由官方定性。",
    ],
  },
  {
    id: 2,
    category: "医疗健康",
    title: "“睡前手机越玩越清醒，会永久损伤睡眠”的说法有依据吗？",
    date: "2026-09-02",
    status: "partial",
    summary:
      "短时来看蓝光确实会推迟入睡、影响褪黑素分泌，但“永久损伤”属于夸大。我们区分了即时影响与长期后果，给出分级结论。",
    tags: ["科普修正", "程度夸大", "可恢复"],
    verdict: [
      "多项对照研究显示，睡前高亮屏会延长入睡潜伏期约 5–10 分钟，属即时影响。",
      "睡眠节律的短期紊乱在减少暴露后多可恢复，未见“永久损伤”的直接证据。",
      "结论：影响真实存在，但需限定程度与场景，不构成“永久伤害”。",
    ],
  },
  {
    id: 3,
    category: "消费电商",
    title: "某头部直播间宣称“原产地直采、比批发价还低”可信吗？",
    date: "2026-08-30",
    status: "confirmed",
    summary:
      "经对货源单据、发货仓地址与同款渠道比价，发现其“直采”表述与多级分销链路不符，价格亦非全网最低，属夸大宣传。",
    tags: ["夸大宣传", "货源存疑", "已坐实"],
    verdict: [
      "物流轨迹显示发货地经多个中转仓，与“产地直发”表述不一致。",
      "同一商品在授权经销渠道存在更低价，与“比批发价还低”的说法矛盾。",
      "关联主体已在整改说明中调整宣传口径，相关表述存在虚假成分。",
    ],
  },
  {
    id: 4,
    category: "政策法规",
    title: "网传“取消医保门诊报销额度”是真的吗？",
    date: "2026-08-26",
    status: "refuted",
    summary:
      "系将部分地区“起付线调整”误读为“全面取消额度”。官方文件明确门诊统筹政策维持不变，仅个别统筹地区优化了起付与封顶规则。",
    tags: ["政策误读", "以偏概全"],
    verdict: [
      "检索各地医保局近一年文件，未出现“全面取消门诊额度”的表述。",
      "个别地区调整的是年度封顶线的计算口径，属优化而非取消。",
      "被广泛转发的图片截自政策解读草稿，未加盖公章、不具效力。",
    ],
  },
  {
    id: 5,
    category: "娱乐圈",
    title: "“某剧组因演员轧戏导致停工损失千万”的爆料有实锤吗？",
    date: "2026-08-22",
    status: "reversed",
    summary:
      "最初仅有匿名聊天记录流传，后剧组与演员方先后回应，片场时间表与差旅记录曝光，证明停工系排期与天气原因，爆料出现反转。",
    tags: ["匿名爆料", "反转", "当事人澄清"],
    verdict: [
      "首轮传播仅有截图，无署名、无原始出处，证据强度不足。",
      "剧组公开排期表显示该阶段无演员档期冲突，停工另有排期原因。",
      "相关差旅与天气记录佐证澄清内容，原爆料方向被推翻。",
    ],
  },
  {
    id: 6,
    category: "社会热点",
    title: "“某地出台‘限购升级’，外地户籍暂停购房”传闻核实",
    date: "2026-08-18",
    status: "reviewing",
    summary:
      "该信息源于社交平台一张未经证实的文件截图，截至发稿属地住建部门尚未发布正式文件，我们已同步多路渠道核验中。",
    tags: ["核实中", "文件存疑"],
    verdict: [
      "所传截图缺发布主体与文件编号，真实性待确认。",
      "已向属地公开咨询渠道提交核查，正在等待官方口径。",
      "在正式文件公布前，相关传闻暂不认定也不否认，避免误导交易。",
    ],
  },
  {
    id: 7,
    category: "消费电商",
    title: "“某些测评榜单由品牌方付费上榜”的质疑成立吗？",
    date: "2026-08-15",
    status: "confirmed",
    summary:
      "比对多份榜单的评测样本来源与送测主体，发现部分参评样品由品牌方提供且榜单排序与投放存在关联，商业属性未被充分披露。",
    tags: ["商业关联", "利益披露缺失", "已坐实"],
    verdict: [
      "多期榜单的参评商品集中于投放品牌，覆盖明显不均。",
      "送测记录显示样品来源含品牌寄样，评测独立性存疑。",
      "涉事机构后续补充了“合作标识”，承认排序含商业因素。",
    ],
  },
  {
    id: 8,
    category: "娱乐圈",
    title: "“某艺人参加综艺前被恶意剪辑”的争议如何定论？",
    date: "2026-08-11",
    status: "partial",
    summary:
      "完整花絮与正片对比显示，确实存在将冲突片段提前置入预告的编排，但正片对话经逐帧核对基本完整，夸大的是“恶意”程度。",
    tags: ["剪辑争议", "部分属实"],
    verdict: [
      "预告片为制造悬念对冲突进行了前置，存在断章取义的观感。",
      "正片保留完整语境，关键对话未发现删改实质内容。",
      "结论：编排问题属实，但上升为“恶意构陷”证据不足。",
    ],
  },
];

export interface TimelineStep {
  stage: string;
  title: string;
  desc: string;
  tone: "neutral" | "ferment" | "confirm" | "clarify" | "reversal";
}

export const timelineSteps: TimelineStep[] = [
  {
    stage: "第 1 步",
    title: "传闻出现",
    desc: "匿名聊天记录或单张截图开始在小范围群聊中传播，通常不注明来源与时间。",
    tone: "neutral",
  },
  {
    stage: "第 2 步",
    title: "网络发酵",
    desc: "情绪化标题被转进多个平台，转发量激增，原始语境与背景信息开始丢失。",
    tone: "ferment",
  },
  {
    stage: "第 3 步",
    title: "证据核验",
    desc: "我们回溯原始素材、比对时间线，并向可查证的信息源逐一求证。",
    tone: "confirm",
  },
  {
    stage: "第 4 步",
    title: "当事人回应",
    desc: "梳理当事方公开澄清，判断其是否有可核验的证据支撑，而非仅有表态。",
    tone: "clarify",
  },
  {
    stage: "第 5 步",
    title: "定论或反转",
    desc: "依据证据完整度给出“有实锤、查无实据、部分属实”等结论，必要时标注反转。",
    tone: "reversal",
  },
];

export interface GuideCard {
  icon: string;
  no: string;
  title: string;
  desc: string;
}

export const guides: GuideCard[] = [
  {
    icon: "ri-database-2-line",
    no: "01",
    title: "查信息源",
    desc: "一条可信传闻至少要有明确的原始出处。匿名截图、无署名的“爆料”与无法溯源转贴，证据强度天然偏低，先标记为待核验。",
  },
  {
    icon: "ri-link-m",
    no: "02",
    title: "看证据链",
    desc: "单一截图不足为凭。把时间、地点、人物、前后语境串成一条完整线索，断档越多，越要谨慎。能互相印证的证据才接近“实锤”。",
  },
  {
    icon: "ri-time-line",
    no: "03",
    title: "对时间线",
    desc: "把传闻放进时间轴里比对。很多反转来自“旧闻翻炒”或“掐头去尾”，核对事发时间与通报日期，能快速排除一大类假传闻。",
  },
  {
    icon: "ri-megaphone-line",
    no: "04",
    title: "等当事人",
    desc: "当事方的澄清是否有效，取决于有没有证据支撑，而不只是“否认”本身。把澄清内容与既有证据并列，再判断结论是否改变。",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "“55黑料”里的内容到底是真的还是假的？",
    a: "我们没有一刀切的“真或假”结论。不同传闻的性质、证据链和当事人回应都不同，我们按“有实锤、查无实据、部分属实、反转中、核实中”五种状态逐条给出判断，并附上时间线与证据要点，把来龙去脉摊开给你自行权衡。",
  },
  {
    q: "一条传闻要满足哪些条件才能被认定为“实锤”？",
    a: "通常需同时满足三点：一是有可核验的原始信息源，如带完整语境的截图、音视频或官方文件；二是证据链完整、时间连续、前后不矛盾；三是能与当事方的公开回应相互印证。缺少任一环节，我们都会标为“核实中”或“查无实据”，不会轻易下结论。",
  },
  {
    q: "为什么很多传闻最后会“反转”？",
    a: "反转大多源于信息不完整或被断章取义：前期只有单方面截图或掐头去尾的片段，缺少上下文，随后完整记录、原始素材或当事人澄清曝光，结论随之改变。所以我们在早期传播阶段会明确提示“证据待补全”，避免你被带偏。",
  },
  {
    q: "当事人澄清之后，之前流传的传闻还算数吗？",
    a: "澄清是否有效，取决于它是否附带可核验的证据，而不只是“否认”这一动作。我们不会因为一条声明就推翻旧结论，而是把“澄清内容”“补充证据”“既有证据”并列呈现，同步标注最新进展，结论由你基于完整信息来判断。",
  },
  {
    q: "看到一条想求证的消息，我可以怎么提交线索？",
    a: "在页面底部“线索提交”区填入事件简述、你的称呼与联系方式即可，我们会按信息源、证据链、时间线三步核验，并在结果页更新结论。对暂时无法证实的线索，我们会如实标注“核实中”，绝不为了热度抢发。",
  },
];

export interface PrincipleItem {
  icon: string;
  title: string;
  desc: string;
}

export const principles: PrincipleItem[] = [
  {
    icon: "ri-scales-3-line",
    title: "先求证，后下结论",
    desc: "结论只建立在可核验的证据之上。证据不足时，宁可标注“核实中”，也不抢先定性。",
  },
  {
    icon: "ri-eye-off-line",
    title: "不靠标题吓人",
    desc: "不用情绪化标题制造焦虑，尽量把断章取义的原语境还给读者，让信息完整可见。",
  },
  {
    icon: "ri-refresh-line",
    title: "错了就改",
    desc: "一旦证据指向结论需要修正，我们会公开更新状态与理由，反转不是什么丢脸的事。",
  },
  {
    icon: "ri-contacts-line",
    title: "对事不对人",
    desc: "我们讨论的是事实与证据本身，不针对任何个体的私生活做无依据的指控或猎奇。",
  },
];

export interface VoiceItem {
  name: string;
  role: string;
  quote: string;
}

export const voices: VoiceItem[] = [
  {
    name: "阿澄",
    role: "资讯编辑 · 读者 3 年",
    quote: "这里有别的平台给不了的东西——它会告诉你“为什么这条是假的”，把来龙去脉讲清楚，而不是只丢一个结论。",
  },
  {
    name: "老周",
    role: "前从业者 · 长期关注",
    quote: "看多了反转，最怕被带节奏。这里每条都会标证据链和时间线，比单纯刷标题安心得多，转发前我会先来这里查一下。",
  },
  {
    name: "Momo",
    role: "在校学生 · 新读者",
    quote: "第一次来是查一条被疯传的消息，结果发现是旧闻。后来养成习惯，看到疑似夸张的内容就来搜状态标签，挺省心。",
  },
];